import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux';

import configureStore from './store';
import routeMap, { setupCommonElements } from './utils/routeMap';
import scrollElementIntoView, { scrollElementIntoViewById, scrollErrorsIntoView } from './utils/scrollElemntIntoView';
import handleCustomFileFields from './utils/handleCustomFileFields';

if (DJ_CONST.SENTRY_DSN) {
    Sentry.init({
        dsn: DJ_CONST.SENTRY_DSN,
        environment: DJ_CONST.SENTRY_ENVIRONMENT,
        beforeSend(event, hint) {
            // Check if it is an exception, and if so, show the report dialog
            if (event.exception) {
                Sentry.showReportDialog({ eventId: event.event_id });
            }
            return event;
        },
    });
    // If we have authenticated user, pass its data on to Sentry
    if (DJ_CONST.user) {
        Sentry.setContext('user', {
            id: DJ_CONST.user.id,
            email: DJ_CONST.user.email,
            name: DJ_CONST.user.name,
            is_staff: DJ_CONST.user.is_staff,
        });
    }
}

function init(routeName) {
    const route = Object.keys(routeMap).find((x) => {
        const regex = new RegExp(x);
        return regex.test(routeName);
    });

    let configs = routeMap[route];
    if (!(configs && configs.excludeCommon)) {
        configs = {
            ...setupCommonElements(),
            ...configs,
        };
    }

    if (!configs) {
        return [];
    }

    const stores = {};

    Object.keys(configs).forEach((selector) => {
        const config = configs[selector];
        const matches = document.querySelectorAll(selector);

        const props = config.props instanceof Function ? config.props() : config.props;
        // people don't like this hack because other people are dumb
        // don't be dumb - learn javascript before complaining about it on the internet
        [].forEach.call(matches, (elem) => {
            if (!config.reducer) {
                ReactDOM.render(<config.component {...props} {...elem.dataset} />, elem);
                return;
            }

            let store;
            if ('store' in config && config.store in stores) {
                store = stores[config.store];
            } else {
                store = configureStore(config.reducer);
                stores['store' in config ? config.store : `${routeName}-${selector}`] = store;
            }

            ReactDOM.render(
                <Sentry.ErrorBoundary>
                    <Provider store={store}>
                        <config.component {...props} {...elem.dataset} />
                    </Provider>
                </Sentry.ErrorBoundary>,
                elem,
            );
        });
    });

    return stores;
}

function smoothLinks() {
    // For some unknown reasons, maybe interfering extensions, instead of a NodeList as per the spec
    // the document.querySelectorAll() call sometimes returns Objects, undefineds...
    document?.querySelectorAll?.('a[href^="#"]')?.forEach?.((anchor) => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        });
    });
}

export {
    init,
    smoothLinks,
    scrollElementIntoView,
    scrollErrorsIntoView,
    scrollElementIntoViewById,
    handleCustomFileFields,
}; // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/main.js